/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

require('spark-bootstrap');

if (typeof window.Vue != 'undefined') {
    require('./../assets/js/components/bootstrap');

    var app = new Vue({
        mixins: [
            require('spark'),
        ],
    });

    // vueKanban = require('vue-kanban');
    // Vue.use(vueKanban);
}

window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

window.Pusher = require('pusher-js');
import Echo from 'laravel-echo';

if(typeof window.pusher_options !== "undefined"){
    window.Echo = new Echo(window.pusher_options);
}

(function () { // IIFE
    function beforePrint() {
        let ev = new Event('beforeprint.enee');
        window.dispatchEvent(ev);
    }

    function afterPrint() {
        let ev = new Event('afterprint.enee');
        window.dispatchEvent(ev);
    }

    if (window.matchMedia) {
        var mediaQueryList = window.matchMedia('print');
        if (typeof mediaQueryList.addEventListener !== 'function') {
            mediaQueryList.addListener(function (ev) {
                if (ev.matches) {
                    beforePrint();
                } else {
                    afterPrint();
                }
            });
        } else {
            // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/change_event
            mediaQueryList.addEventListener('change', function (ev) {
                if (ev.matches) {
                    beforePrint();
                } else {
                    afterPrint();
                }
            });
        }
        document.addEventListener('DOMContentLoaded', function () {
            let debouncedBeforePrint = _.debounce(beforePrint, 500);
            $(document).on('draw.dt', function () {
                if (mediaQueryList.matches) { // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/matches
                    debouncedBeforePrint();
                }
            });
        });
    }
    // Fallback if matchMedia isn't available
    else {
        window.addEventListener('onbeforeprint', beforePrint);
        window.addEventListener('onafterprint', afterPrint);
        // Use elsewhere if needed:
        // window.removeEventListener('onbeforeprint', beforePrint)
        // window.removeEventListener('onafterprint', afterPrint)
    }
})(); // IIFE
